import { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import QRCode from 'qrcode';
import { DEFAULT_KIOSK_TIMEOUT_MS, fetchKioskTimeoutMs } from '../../api/kioskAdmin';
import CloseIcon from '../icons/CloseIcon';

function ExpiredModal({ show, extendTicketUrl, onHide, onTimeout }) {
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [left, setLeft] = useState(null);
  const onHideRef = useRef(onHide);
  const onTimeoutRef = useRef(onTimeout);
  onHideRef.current = onHide;
  onTimeoutRef.current = onTimeout;

  useEffect(() => {
    setQrCodeUrl('');
    if (!extendTicketUrl) return undefined;

    let cancelled = false;
    QRCode.toDataURL(extendTicketUrl, {
      errorCorrectionLevel: 'H',
      margin: 1,
      width: 340,
      color: { dark: '#000000', light: '#FFFFFF' },
    })
      .then((url) => {
        if (!cancelled) setQrCodeUrl(url);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [extendTicketUrl]);

  useEffect(() => {
    if (!show) {
      setLeft(null);
      return undefined;
    }
    let cancelled = false;
    let timer = 0;
    fetchKioskTimeoutMs().then((ms) => {
      if (cancelled) return;
      const totalMs = ms > 0 ? ms : DEFAULT_KIOSK_TIMEOUT_MS;
      const total = Math.max(1, Math.ceil(totalMs / 1000));
      const started = Date.now();
      const tick = () => {
        const elapsed = Math.floor((Date.now() - started) / 1000);
        const remain = Math.max(0, total - elapsed);
        setLeft(remain);
        if (remain > 0) return;
        window.clearInterval(timer);
        timer = 0;
        const close = onTimeoutRef.current || onHideRef.current;
        close?.();
      };
      tick();
      timer = window.setInterval(tick, 250);
    });
    return () => {
      cancelled = true;
      if (timer) window.clearInterval(timer);
    };
  }, [show]);

  const minutes = String(Math.floor((left || 0) / 60)).padStart(2, '0');
  const remain = String((left || 0) % 60).padStart(2, '0');

  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered className="expiredModal">
      <Modal.Body>
        <button
          type="button"
          className="expiredModal__close"
          onClick={onHide}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
        <div className="expiredStamp">Expired</div>
        <h2 className="expiredModal__title">Your ticket is already expired</h2>
        <p className="expiredModal__copy">
          Please scan this QR code to extend your ticket and pay.
        </p>
        <div className="expiredModal__code">
          {qrCodeUrl ? (
            <>
              <img src={qrCodeUrl} alt="Extend ticket QR code" draggable="false" />
              <span className="expiredModal__badge">MOSIDA</span>
            </>
          ) : null}
        </div>
        {left !== null ? (
          <p className="expiredModal__timer" aria-live="polite">
            QR expires in: <strong>{minutes}:{remain}</strong>
          </p>
        ) : null}
      </Modal.Body>
    </Modal>
  );
}

export default ExpiredModal;
